import React from 'react';
import {Typography} from '~library/atoms/Typography';

export const NoResultsHeader = (props) => (
  <div className="gallery__no-search-results-header__wrapper">
    <div className="gallery__no-search-results-header">
      <Typography variant="header2" color="charcoal">
        Uh-oh, we couldn't find any results!
      </Typography>
      <Typography variant="paragraph3" color="charcoal">
        Our navigation filters can help, or you can design your own{' '}
        {window.cards_page ? 'greeting card' : 'invitation'} with one of our templates.
      </Typography>
    </div>
  </div>
);

NoResultsHeader.propTypes = {};
